const globalStyles = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,400;0,9..40,500;0,9..40,600;0,9..40,700&family=Source+Serif+4:ital,opsz,wght@0,8..60,400;0,8..60,600;0,8..60,700&display=swap');

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html, body, #root {
    height: 100%;
    max-height: 100vh;
    margin: 0;
    padding: 0;
    overflow: hidden;
    background: var(--bg-primary);
  }

  body {
    font-family: 'DM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    color: var(--text-primary);
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .drag-over {
    border-color: var(--accent-primary) !important;
    background: var(--accent-subtle-bg) !important;
    box-shadow: 0 0 0 4px var(--accent-subtle-bg) !important;
  }

  @keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }

  @keyframes slideIn {
    from { transform: translateX(100px); opacity: 0; }
    to { transform: translateX(0); opacity: 1; }
  }

  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  @keyframes fadeUp {
    from { opacity: 0; transform: translateY(12px); }
    to { opacity: 1; transform: translateY(0); }
  }

  @keyframes modalIn {
    from { opacity: 0; transform: scale(0.96) translateY(8px); }
    to { opacity: 1; transform: scale(1) translateY(0); }
  }

  /* Scrollbar styling */
  ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  ::-webkit-scrollbar-track {
    background: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background: var(--border-color);
    border-radius: 3px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: var(--text-muted);
  }

  /* Focus outline */
  *:focus-visible {
    outline: 2px solid var(--accent-primary);
    outline-offset: 2px;
  }

  /* Button transitions */
  button {
    transition: all 0.2s ease;
  }

  button:active {
    transform: scale(0.98);
  }

  /* Selection color */
  ::selection {
    background: var(--accent-subtle-bg);
    color: var(--text-primary);
  }

  /* TipTap Editor Styles */
  .tiptap {
    padding: 24px;
    min-height: 100%;
    outline: none;
    color: var(--text-primary);
    font-size: 15px;
    line-height: 1.8;
    font-family: 'DM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  }

  .tiptap h1 {
    font-size: 32px;
    font-weight: 700;
    margin-bottom: 20px;
    line-height: 1.3;
    color: var(--text-primary);
  }

  .tiptap h2 {
    font-size: 24px;
    font-weight: 600;
    margin-top: 32px;
    margin-bottom: 16px;
    line-height: 1.3;
    color: var(--text-primary);
  }

  .tiptap h3 {
    font-size: 20px;
    font-weight: 600;
    margin-top: 24px;
    margin-bottom: 12px;
    line-height: 1.3;
    color: var(--text-primary);
  }

  .tiptap p {
    margin-bottom: 16px;
    color: var(--text-secondary);
  }

  .tiptap strong {
    font-weight: 700;
    color: var(--text-primary);
  }

  .tiptap em {
    font-style: italic;
  }

  .tiptap u {
    text-decoration: underline;
  }

  .tiptap blockquote {
    border-left: 3px solid var(--accent-primary);
    padding-left: 16px;
    margin: 16px 0;
    color: var(--text-secondary);
    font-style: italic;
  }

  .tiptap ul, .tiptap ol {
    padding-left: 24px;
    margin-bottom: 16px;
  }

  .tiptap li {
    margin-bottom: 4px;
    color: var(--text-secondary);
  }

  /* Article Preview Styles */
  .article-preview h1 {
    font-size: 32px;
    font-weight: 700;
    margin-bottom: 20px;
    line-height: 1.3;
    color: var(--text-primary);
  }

  .article-preview h2 {
    font-size: 24px;
    font-weight: 600;
    margin-top: 32px;
    margin-bottom: 16px;
    line-height: 1.3;
    color: var(--text-primary);
  }

  .article-preview h3 {
    font-size: 20px;
    font-weight: 600;
    margin-top: 24px;
    margin-bottom: 12px;
    line-height: 1.3;
    color: var(--text-primary);
  }

  .article-preview p {
    font-size: 16px;
    line-height: 1.8;
    color: var(--text-secondary);
    margin-bottom: 16px;
  }

  .article-preview strong {
    font-weight: 700;
    color: var(--text-primary);
  }

  .article-preview em {
    font-style: italic;
  }

  .article-preview u {
    text-decoration: underline;
  }

  .article-preview blockquote {
    border-left: 3px solid var(--accent-primary);
    padding-left: 16px;
    margin: 16px 0;
    color: var(--text-secondary);
    font-style: italic;
  }

  .article-preview ul, .article-preview ol {
    padding-left: 24px;
    margin-bottom: 16px;
  }

  .article-preview li {
    margin-bottom: 4px;
    font-size: 16px;
    line-height: 1.8;
    color: var(--text-secondary);
  }

  /* Mobile responsive */
  @media (max-width: 768px) {
    aside {
      display: none !important;
    }

    main {
      width: 100% !important;
    }

    h1 {
      font-size: 32px !important;
    }
  }

  @media (max-width: 480px) {
    h1 {
      font-size: 28px !important;
    }
  }
`;

export default globalStyles;
